import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const pathsSlice = createSlice({
    name: "paths",
    initialState,
    reducers: {
        pathAdded(state, action) { 
            if(!state.includes(action.payload)){
                state.push(action.payload);
            }           
        }
    }
});

export const pathsSelector = (state) => state.paths;

export const { pathAdded } = pathsSlice.actions;
export default pathsSlice.reducer;